import { Image } from 'atoms/Image/Image';
import { Span } from 'atoms/Typography';
import styles from './styles.module.css';

export const CategoryItem = ({ onClick, title, image }: any) => (
  <div onClick={onClick} className={styles.answerItem}>
    <Image alt={title} className={styles.answerImg} src={image} />
    <Span className={styles.answerCopy}>{title}</Span>
  </div>
);
